// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Pxg0","clinicsSelect":"styles_clinicsSelect__2dbro"};